import {
  EPublicI9Status,
  EEVerifyPublicCaseStatus,
  EI9AdminReviewStatus,
  ETimePeriod,
  zSchema,
  publicPaginationSchema,
  publicSortSchema,
} from "@zeal/common";

export const getWorkerI9DataCommonSchema = zSchema.object({
  q: zSchema.string().optional(),
  ...publicPaginationSchema.shape,
  ...publicSortSchema.shape,

  // Table filtering options
  everify_status: zSchema
    .union([
      zSchema.nativeEnum(EEVerifyPublicCaseStatus),
      zSchema.array(zSchema.nativeEnum(EEVerifyPublicCaseStatus)),
    ])
    .optional(),
  public_i9_status: zSchema
    .union([
      zSchema.nativeEnum(EPublicI9Status),
      zSchema.array(zSchema.nativeEnum(EPublicI9Status)),
    ])
    .optional(),
  latest_admin_review_status: zSchema
    .union([
      zSchema.nativeEnum(EI9AdminReviewStatus),
      zSchema.array(zSchema.nativeEnum(EI9AdminReviewStatus)),
    ])
    .optional(),
});

export const getWorkerI9DataCustomPeriodSchema = zSchema.object({
  period: zSchema.literal(ETimePeriod.Custom),
  date_from: zSchema.string(),
  date_to: zSchema.string(),
});

export const getWorkerI9DataPresetPeriodSchema = zSchema.object({
  period: zSchema.enum(["7d", "14d", "30d", "60d", "90d"]),
});

// Request schema
export const getWorkerI9DataRequestSchema = zSchema.discriminatedUnion(
  "period",
  [
    getWorkerI9DataCustomPeriodSchema.merge(getWorkerI9DataCommonSchema),
    getWorkerI9DataPresetPeriodSchema.merge(getWorkerI9DataCommonSchema),
  ]
);

// Response schema
export const getWorkerI9DataResponseSchema = zSchema.object({
  tableData: zSchema.array(
    zSchema.object({
      rowId: zSchema.string(),
      employeeID: zSchema.string(),
      created_at: zSchema.string(),
      full_name: zSchema.string(),
      start_date: zSchema.string().nullish(),
      everify_status: zSchema.nativeEnum(EEVerifyPublicCaseStatus).nullish(),
      latest_admin_review_status: zSchema
        .nativeEnum(EI9AdminReviewStatus)
        .nullish(),
      public_i9_status: zSchema.nativeEnum(EPublicI9Status).nullish(),
    })
  ),

  // Pagination
  nextCursor: zSchema.string().nullable(),
  previousCursor: zSchema.string().nullable(),
  hasMore: zSchema.boolean(),
  limit: zSchema.number(),

  // Metadata about the period
  date_range: zSchema.object({
    from: zSchema.string(),
    to: zSchema.string(),
  }),
});

// Type exports
export type TGetWorkerI9DataRequest = zSchema.infer<
  typeof getWorkerI9DataRequestSchema
>;
export type TGetWorkerI9DataResponse = zSchema.infer<
  typeof getWorkerI9DataResponseSchema
>;
